export const environment = {
    production: false,
    name: 'dev',
    api_URL:'https://dev.circledplus.com/api',
    // api_URL:'http://localhost:3000/api',
    enableDebug: true,
  };